import { BillingPeriod } from '@fieldmargin/webapp-styling/components/pricing/BillingPeriodSwitcher';

export interface Plan {
    uuid: string;
    interval: BillingPeriod;
    currency: string;
    priceInCents: number;
}

export interface Product {
    uuid: string;
    name: string;
    description: string;
    plans: Plan[];
}

const EU_COUNTRY_CODES = [
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'EL',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
];

const AFRICAN_COUNTRY_CODES = [
    'DZ',
    'AO',
    'BJ',
    'BW',
    'BF',
    'BI',
    'CM',
    'CV',
    'CF',
    'KM',
    'CD',
    'DJ',
    'EG',
    'GQ',
    'ER',
    'ET',
    'GA',
    'GM',
    'GH',
    'GN',
    'GW',
    'CI',
    'KE',
    'LS',
    'LR',
    'LY',
    'MG',
    'MW',
    'ML',
    'MR',
    'MU',
    'MA',
    'MZ',
    'NA',
    'NE',
    'NG',
    'CG',
    'RE',
    'RW',
    'SH',
    'ST',
    'SN',
    'SC',
    'SL',
    'SO',
    'ZA',
    'SS',
    'SD',
    'SZ',
    'TZ',
    'TG',
    'TN',
    'UG',
    'EH',
    'ZM',
    'ZW',
];

export const getCountryCurrency = (country: string) => {
    if (country === 'GB') {
        return 'GBP';
    }
    if (country === 'US') {
        return 'USD';
    }
    if (country === 'AU') {
        return 'AUD';
    }
    if (country === 'NZ') {
        return 'NZD';
    }
    if (country === 'CA') {
        return 'CAD';
    }
    if (EU_COUNTRY_CODES.indexOf(country) >= 0) {
        return 'EUR';
    }
    if (AFRICAN_COUNTRY_CODES.indexOf(country) >= 0) {
        return 'ZAR';
    }
    return 'GBP';
};

export const getPlanMonthlyPrice = (
    products: Product[],
    productName: string,
    currency: string,
    interval: BillingPeriod
) => {
    const price =
        (products
            .find((product) => product.name === productName)
            ?.plans.find((plan) => plan.currency === currency && plan.interval === interval)
            ?.priceInCents || 0) / 100;

    // We always want to return a monthly price so if the interval is annually we need to divide
    // by 12 to get that.
    return interval === 'annually' ? price / 12 : price;
};
